import { AsyncSelectWithServerProps } from 'vnetwork-ui/dist/components/AsyncSelectWithServer'
import { AsyncSelectWithServer as AsyncSelectWithServerVNW } from 'vnetwork-ui'
import { useQuery } from '@tanstack/react-query'

const AsyncSelectWithServer = <T extends object>(
    props: Omit<AsyncSelectWithServerProps<T>, 'useQuery'>
) => {
    // @ts-ignore
    return <AsyncSelectWithServerVNW {...props} useQuery={useQuery} />
}

export default AsyncSelectWithServer
